// ChatBubble.js
import React from 'react';

const ChatBubble = ({ text, isUser }) => {
  const bubbleStyle = {
    maxWidth: '70%',
    padding: '0.75rem 1rem',
    borderRadius: '15px',
    marginBottom: '0.5rem',
    background: isUser ? '#dcf8c6' : '#f1f0f0', // verde claro si es usuario
    alignSelf: isUser ? 'flex-end' : 'flex-start',
    whiteSpace: 'pre-wrap',
    boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
  };

  return <div style={bubbleStyle}>{text}</div>;
};

export default ChatBubble;
